import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useHistory, useParams } from "react-router-dom";
import { Auth } from 'aws-amplify';
import {
    Button,
    Divider,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
    FormGroup,
    Grid,
    IconButton,
    TextField,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress  from '@material-ui/core/LinearProgress';
import HelpIcon from '@material-ui/icons/Help';
import { makeStyles } from '@material-ui/core/styles';
import TlmBreadcrumbs from '../Components/TlmBreadcrumbs.jsx';
import { host } from "../../data";
import Geocode from "react-geocode";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { countries } from "../../data";
import { isValidEmail } from '../../helpers/isValidEmail';
import { useTranslation } from 'react-i18next';
import { ConsoleLogger } from "@aws-amplify/core";

Geocode.setApiKey("AIzaSyDZxhyTnVftkwNDwT2dR8ygpsztsBBwrxs"); // https://www.npmjs.com/package/react-geocode

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    textInput: {
        margin: theme.spacing(1),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 360
    },
    formControlShort: {
        margin: theme.spacing(1),
        minWidth: 180
    },
    preLoader: {
        display: 'block',
        margin: `${theme.spacing(3)}px auto`,
    },
}));

export default function SiteSettingsPage({ orgInfo, branchInfo, siteInfo, resetSiteData }) {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    // Get params so we can read the url path parameters
    const params = useParams();
    const site = params.siteName === undefined ? null : params.siteName;
    const siteId = params.siteName === undefined ? null : siteInfo.sitesNavDict[site][0];

    const [processingSave, setProcessingSave] = useState(false);
    // TODO: SiteSettingPage - Handle case where it's an edit instead of new.
    //const site_name = useRef("");
    const site_name = useRef("");
    const [siteName, setSiteName] = useState("")
    const site_address_line_1 = useRef("");
    const [siteAddress, setSiteAddress] = useState("");
    const site_phone = useRef("");
    const [sitePhone, setSitePhone] = useState("");
    const site_contact_name = useRef("");
    const [siteContactName, setSiteContactName] = useState("");
    const site_email = useRef("");
    const [siteEmail, setSiteEmail] = useState("");
    const site_city = useRef("");
    const [siteCity, setSiteCity] = useState("");

    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");
    const site_tag = useRef("");
    const [siteTag, setSiteTag] = useState("");

    const [orgTags, setOrgTags] = useState([]);
    const [selectAddTag, setSelectAddTag] = useState("");

    const [selectADU_AVG, setSelectADU_AVG] = useState(1);
    const avgSettings = [{key:1, label: "1 " + t("month_single")}, 
                         {key:2, label: "2 "+t("months_plural")}, 
                         {key:3, label: "3 "+t("months_plural")},
                         {key:105, label: "5 "+t("days_plural")},
                         {key:107, label: "7 "+t("days_plural")},
                        ];
    
    const [dataReady, setDataReady] = useState(false);

    const [averageHelpOpen, setAverageHelpOpen] = useState(false);
    const handleAverageHelpOpen = () => {
        setAverageHelpOpen(true);
      };
    const handleAverageHelpClose = () => {
        setAverageHelpOpen(false);
    };
    console.log(selectADU_AVG);
    React.useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(data => {
                const sessionToken = data.signInUserSession.idToken.jwtToken;
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': sessionToken
                    }
                };

                fetch(host + '/orgs/' + orgInfo.orgId + '/availabledevices', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.error == "OK") {
                            setOrgTags(data.orgTags);
                        }
                        else {
                            alert(data.error);
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
            });
    }, [site]);

    React.useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(data => {
                if (null !== site) {
                    var requestOptions = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                    };
                    fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId, requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            setSiteName(data.name);
                            setSiteCity(data.city);
                            setSiteAddress(data.address);

                            if (data.phone) {
                                setSitePhone(data.phone);
                            }

                            setSiteContactName(data.contact_name)
                            setSiteEmail(data.contact_email)
                            setCountry(data.country);
                            setRegion(data.state);

                            if (data.tags) {
                                setSiteTag(data.tags);
                            }
                            setSelectADU_AVG(data.adu_avg);

                            setDataReady(true);
                        }).catch((error) => {
                            console.log(error)
                        })
                }
                else { //New Tank
                    setDataReady(true);
                }

                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                };
                fetch(host + '/orgs/' + orgInfo.orgId + '/availabledevices', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.error = "OK") {
                            setOrgTags(data.orgTags);
                        }
                        else {
                            alert(data.error);
                        }
                    }).catch((error) => {
                    });

            });
    }, [site]);

    function isValidEnteredEmail(value) {
        if (value === "")
            return (true);

        if (isValidEmail(value))
            return (true);

        alert(t("youHaveEnteredAnInvalidEmail"));
        return (false);
    };

    function isValidPhoneNumber(value) {
        if (value === "")
            return (true);

        if ((/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ''))) {
            return (true);
        }
        alert(t("youHaveEnteredAnInvalidPhone"));
        return (false);
    }

    const handleChangeCountry = (event) => {
        setCountry(event.target.value);
    };

    const handleChangeRegion = (event) => {
        setRegion(event.target.value);
    };

    const handleAddTag = (tag) => {
        var tempTags = siteTag;
        if (tag !== null) {
            if (tempTags !== null && tempTags !== "") {
                tempTags = tempTags + "," + tag;
            }
            else {
                tempTags = tag;
            }

            setSiteTag(tempTags);
        }
        setSelectAddTag(tag);
    }

    function validateForm() {
        var ret = 1;

        if (site_name.current.value === "") {
            alert(t("nameInvalid"));
            ret = 0;
        }

        if (site_address_line_1.current.value === "") {
            alert(t("addressInvalid"));
            ret = 0;
        }

        if (region === "") {
            alert(t('stateRegionInvalid'));
            ret = 0;
        }

        if (country === "") {
            alert(t("countryInvalid"));
            ret = 0;
        }

        if (site_city.current.value === "") {
            alert(t("cityInvalid"));
            ret = 0;
        }

        return ret;
    }

    const handleClick = async () => {
        setProcessingSave(true);
        handleClick2()
    }
    const handleClick2 = async () => {
        if (isValidEnteredEmail(site_email.current.value) && isValidPhoneNumber(site_phone.current.value) && validateForm()) {
            console.log("Save Site Data");
            try {
                let user = await Auth.currentAuthenticatedUser();
                user.getSession((err, session) => {
                    if (err) {
                        console.log(err);
                        return;
                    }

                    try {
                        var address = site_address_line_1.current.value + ' ' + site_city.current.value + ' ' + region + ' ' + country;
                        if (site_address_line_1.current.value !== "") {
                            Geocode.fromAddress(address).then(
                                (response) => {
                                    const { lat, lng } = response.results[0].geometry.location;
                                    const temp_site_name = site_name.current.value;
                                    var tTags = site_tag.current.value;
                                    var TagsList = tTags.split(",");
                                    for (var i = 0; i < TagsList.length; i++) {
                                        TagsList[i] = TagsList[i].trim();
                                    }
                                    tTags = TagsList.join();
                                    setSiteTag(tTags);
                                    var body = JSON.stringify(
                                        {
                                            "Name": site_name.current.value,
                                            "Address": site_address_line_1.current.value,
                                            "Phone": site_phone.current.value,
                                            "ContactName": site_contact_name.current.value,
                                            "Email": site_email.current.value,
                                            "Country": country,
                                            "City": site_city.current.value,
                                            "State": region,
                                            "Latitude": lat,
                                            "Longitude": lng,
                                            "ParentId": branchInfo.branchId,
                                            'User': user.attributes.email,
                                            "Tags": tTags,
                                            "adu_avg": selectADU_AVG
                                        }
                                    );

                                    if (siteId) {
                                        //UpdateSite
                                        var requestOptions = {
                                            method: 'PUT',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': session.getIdToken().jwtToken
                                            },
                                            body: body
                                        };

                                        fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId, requestOptions)
                                            .then(async response => {
                                                return { body: await response.json(), status: response.status };
                                            })
                                            .then(data => {
                                                if (data.status === 200) {
                                                    resetSiteData(temp_site_name);
                                                    //setProcessingSave(false); // For Test
                                                }
                                                else {
                                                    setProcessingSave(false);
                                                    console.log(data);
                                                    alert(data.body);
                                                }
                                            });
                                    }
                                    else {
                                        //New Site
                                        var requestOptions = {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': session.getIdToken().jwtToken
                                            },
                                            body: body
                                        };

                                        fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites', requestOptions)
                                            .then(async response => {
                                                return { body: await response.json(), status: response.status };
                                            })
                                            .then(data => {
                                                if (data.status === 200) {
                                                    let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName) };
                                                    resetSiteData();
                                                    history.push(url);
                                                }
                                                else {
                                                    setProcessingSave(false);
                                                    console.log(data);
                                                    alert(data.body);
                                                }
                                            });
                                    }
                                },
                                (error) => {
                                    console.log(error);
                                }
                            );
                        } else {
                            const temp_site_name = site_name.current.value;
                            var tTags = site_tag.current.value;
                            var TagsList = tTags.split(",");

                            for (var i = 0; i < TagsList.length; i++) {
                                TagsList[i] = TagsList[i].trim();
                            }

                            tTags = TagsList.join();
                            setSiteTag(tTags);

                            var body = JSON.stringify(
                                {
                                    "Name": site_name.current.value,
                                    "Address": "",
                                    "Phone": site_phone.current.value,
                                    "ContactName": site_contact_name.current.value,
                                    "Email": site_email.current.value,
                                    "Country": country,
                                    "City": site_city.current.value,
                                    "State": region,
                                    "Latitude": 0,
                                    "Longitude": 0,
                                    "ParentId": branchInfo.branchId,
                                    'User': user.attributes.email,
                                    "Tags": tTags
                                }
                            );

                            if (siteId) {
                                //UpdateSite
                                var requestOptions = {
                                    method: 'PUT',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': session.getIdToken().jwtToken
                                    },
                                    body: body
                                };

                                fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId, requestOptions)
                                    .then(async response => {
                                        return { body: await response.json(), status: response.status };
                                    })
                                    .then(data => {
                                        if (data.status === 200) {
                                            resetSiteData(temp_site_name);
                                            //setProcessingSave(false); // For Test
                                        }
                                        else {
                                            setProcessingSave(false);
                                            alert(data.body);
                                        }
                                    });
                            }
                            else {
                                //New Site
                                var requestOptions = {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': session.getIdToken().jwtToken
                                    },
                                    body: body
                                };

                                fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites', requestOptions)
                                    .then(async response => {
                                        return { body: await response.json(), status: response.status };
                                    })
                                    .then(data => {
                                        if (data.status === 200) {
                                            let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName) };
                                            resetSiteData();
                                            history.push(url);
                                        }
                                        else {
                                            setProcessingSave(false);
                                            alert(data.body);
                                        }
                                    });
                            }
                        }
                    } catch (err) {
                        console.log(err);
                        setProcessingSave(false);
                    } finally {
                        
                    }
                });
            } catch (e) {
                console.log(e);
                setProcessingSave(false);
            }
        }
        else{
            setProcessingSave(false);
        }
    };
    const handleCancelClick = () => {
        if (siteId) {
            let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName).concat('/sites/').concat(site) };
            history.push(url);
        }
        else {
            let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName) };
            history.push(url);
        }
    };
    
    return (
        !dataReady ? <Grid container 
        direction='column'
        alignItems='center'
        justifyContent='center'> 
            <Grid item xs> <Typography>{t("loadingSiteData")}</Typography></Grid>
            <Grid item xs> <CircularProgress className={classes.preLoader} /> </Grid>
        </Grid> :
        <Grid container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            className={classes.content}>
            
            <Grid item xs>
                <Toolbar>
                    {site === null
                        ? <TlmBreadcrumbs edge='start'
                            orgInfo={orgInfo}
                            branchInfo={branchInfo}
                            site={t("addNewSite")}
                            tank={null} />
                        : <TlmBreadcrumbs edge='start'
                            orgInfo={orgInfo}
                            branchInfo={branchInfo}
                            site={site}
                            tank={t("edit")} />}
                </Toolbar>
            </Grid>
            <Divider />
            {processingSave && <Grid container 
                direction='row'
                alignItems='center'
                justifyContent='center'> 
                <Grid item xs> <LinearProgress className={classes.preLoader} /> </Grid>
            </Grid>}
            <Grid item xs>
                <form>
                    <Typography>
                        {t("siteDetails")}
                    </Typography>
                    <FormGroup>
                        <TextField id='site-name'
                            required
                            disabled={processingSave}
                            inputRef={site_name}
                            value={siteName}
                            onChange={(e) => {
                                const regex = /^([ a-zA-Z0-9\-]){0,40}$/i;
                                if (regex.test(e.target.value)) {
                                    setSiteName(e.target.value);
                                }
                            }}
                            label={t("siteName")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='site-address-line-1'
                            required
                            disabled={processingSave}
                            inputRef={site_address_line_1}
                            value={siteAddress}
                            onChange={e => setSiteAddress(e.target.value)}
                            label={t("address")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='site-city'
                            required
                            disabled={processingSave}
                            inputRef={site_city}
                            value={siteCity}
                            onChange={e => setSiteCity(e.target.value)}
                            label={t("city")}
                            variant='filled'
                            className={classes.textInput} />
                        <FormControl className={classes.formControl}>
                            <InputLabel required id="country-select-label">{t("country")}</InputLabel>
                            <Select
                                disabled={processingSave}
                                labelId="country-select-label"
                                id="country-select"
                                value={country}
                                onChange={handleChangeCountry} >
                                {countries.map((country) => (
                                    <MenuItem
                                        value={country.countryName}
                                        key={country.countryShortCode}
                                    >
                                        {t(country.translationKey)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel required id="region-select-label">{t("stateProvinceRegion")}</InputLabel>
                            <Select
                                labelId="region-select-label"
                                id="region-select"
                                value={region}
                                onChange={handleChangeRegion}
                                disabled={!country || processingSave} >
                                {country
                                    ? countries
                                        .find(({ countryName }) => countryName === country)
                                        .regions.map((region) => (
                                            <MenuItem value={region.name} key={region.shortCode}>
                                                {t(region.translationKey)}
                                            </MenuItem>
                                        )) : []}
                            </Select>
                        </FormControl>
                        <Grid item container
                            direction='row'
                            rowSpacing={1}
                        >
                            <Typography className={classes.textInput}>{t("averagingWindow")}</Typography>
                            <FormControl className={classes.formControlShort} >
                                    <Select
                                        disabled={processingSave}
                                        value={selectADU_AVG}
                                        onChange={e => {
                                            setSelectADU_AVG(e.target.value);
                                        }}>
                                        {avgSettings.map(avgListItem => <MenuItem key={avgListItem.key} value={avgListItem.key}>
                                            {avgListItem.label}
                                        </MenuItem>)}
                                    </Select>
                                </FormControl>
                                <Tooltip title={t("info")}>
                                    <IconButton onClick={handleAverageHelpOpen}>
                                    <HelpIcon />
                                    </IconButton>
                                </Tooltip>
                        </Grid>
                        <Toolbar>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField id='site-tags'
                                    disabled={processingSave}
                                    inputRef={site_tag}
                                    value={siteTag}
                                    onChange={e => {
                                        const regex = /^([, a-zA-Z0-9\-]){0,200}$/i;
                                        if (regex.test(e.target.value)) {
                                            setSiteTag(e.target.value);
                                        }
                                    }}
                                    label={t("tags")}
                                    helperText={t("commaSeperated")} />
                            </FormControl>
                            <FormControl className={classes.formControl} >
                                <TextField select
                                    disabled={processingSave}
                                    label={t("addTags")}
                                    value={selectAddTag}
                                    helperText={" "}
                                    onChange={e => {
                                        for (var i = 0; i < orgTags.length; i++) {
                                            if (e.target.value === orgTags[i]) {
                                                handleAddTag(orgTags[i]);
                                                break;
                                            }
                                        }
                                    }}>
                                    {orgTags.map(orgTagsListItem => <MenuItem key={orgTagsListItem} value={orgTagsListItem}>
                                        {orgTagsListItem}
                                    </MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Toolbar>

                    </FormGroup>
                    <Typography>
                        {t("siteContact_optional")}
                    </Typography>
                    <FormGroup>
                        <TextField id='site-contact'
                            disabled={processingSave}
                            inputRef={site_contact_name}
                            value={siteContactName}
                            onChange={e => setSiteContactName(e.target.value)}
                            label={t("name")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='site-phone'
                            disabled={processingSave}
                            inputRef={site_phone}
                            value={sitePhone}
                            onChange={e => setSitePhone(e.target.value)}
                            label={t("phoneNumber")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='site-email'
                            disabled={processingSave}
                            inputRef={site_email}
                            value={siteEmail}
                            onChange={e => setSiteEmail(e.target.value)}
                            label={t("email")}
                            variant='filled'
                            className={classes.textInput} />
                    </FormGroup>
                </form>
            </Grid>
            <Grid item xs>
                <Button variant="contained" color='primary' onClick={handleClick} disabled={processingSave}>
                    {t("save")}
                </Button>
                <Button onClick={handleCancelClick} disabled={processingSave}>
                    {t("cancel")}
                </Button>
            </Grid>
            {averageHelpOpen && <Dialog className={classes.infoDialog} disableEscapeKeyDown open={averageHelpOpen} onClose={handleAverageHelpClose}>
                <DialogTitle>{t("dataAverageDefinition")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <Typography paragraph variant="body2">
                        {t("dataAverageExplanation")}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAverageHelpClose} color="primary">
                        {t("close")}
                    </Button>
                </DialogActions>
            </Dialog>}
        </Grid>
        
    )
}
